import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

function ProtectedRouter({ element: Element }) {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.authReducer.isLogin);
  const { accessFolders } = useSelector((state) => state?.commonReducer);

  // Helper function to check if the path is a child of "/folders"
  const isChildOfFolders = location.pathname.startsWith("/folders/") && location.pathname.split('/').length > 2;

  // Render logic
  return (
    <>
      {isAuthenticated ? (
        (isChildOfFolders && !accessFolders) ? (
          <Navigate replace to="/folders" />
        ) : (
          Element
        )
      ) : (
        <Navigate replace to="/login" />
      )}
    </>
  );
}

export default ProtectedRouter;
